import { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from './hooks/redux'
import { getSystemData } from './hooks/systemData'

import { setLanguage } from './store/reducers/app/LanguageSlice'
import { setTheme } from './store/reducers/app/ThemeSlice'

import { Colors } from './constants/Colors'
import { RoutesPath } from './constants/RoutesPath'

import app from './App.module.css'

import ResponseSuccessContainer from './components/widgets/ResponseSuccess/ResponseSuccessContainer'
import ResponseWarningContainer from './components/widgets/ResponseWarning/ResponseWarningContainer'
import ResponseErrorContainer from './components/widgets/ResponseError/ResponseErrorContainer'

import CustomAlert from './components/widgets/CustomAlert/CustomAlert'

import SidebarContainer from './components/Sidebar/SidebarContainer'

import HomeContainer from './pages/Home/HomeContainer'
import TermsOfUseConatiner from './pages/TermsOfUse/TermsOfUseConatiner'
import PrivacyPolicyContainer from './pages/PrivacyPolicy/PrivacyPolicyConatiner'
import ProfileDataContainer from './pages/ProfileData/ProfileDataConatiner'
import AboutUsContainer from './pages/AboutUs/AboutUsContainer'

function App() {
    
    const dispatch = useAppDispatch()

    const theme = useAppSelector(state => state.theme.theme)
    const themeId = useAppSelector(state => state.theme.themeId)
    const themeUpdated = useAppSelector(state => state.theme.update)
    
    const languageUpdated = useAppSelector(state => state.language.update)

    const changeStateLanguage = async () => {
        const language = await getSystemData('language') ?? 'tm'
        dispatch(setLanguage(language))
    }

    const changeStateTheme = async () => {
        const theme = await getSystemData('theme') ?? 'light'
        const themeId = await getSystemData('themeId') ?? '1'
        dispatch(setTheme(theme, themeId))
    }

    useEffect(() => {
        changeStateLanguage()
    }, [languageUpdated])

    useEffect(() => {
        changeStateTheme()
    }, [themeUpdated])

    return (
        <>
            
            <CustomAlert />

            <ResponseSuccessContainer />
            
            <ResponseWarningContainer />

            <ResponseErrorContainer />
        
            <div
                className={app.container}
                style={{
                    color: Colors[theme ?? 'light'].text,
                    backgroundColor: Colors[theme ?? 'light'].background
                }}
            >
                <div className={app.contents}>
                    
                    <SidebarContainer />

                    <Routes>
                        <Route
                            path={RoutesPath.home}
                            element={
                                <HomeContainer />
                            }
                        />
                        <Route
                            path={RoutesPath.termsOfUse}
                            element={
                                <TermsOfUseConatiner />
                            }
                        />
                        <Route
                            path={RoutesPath.privacyPolicy}
                            element={
                                <PrivacyPolicyContainer />
                            }
                        />
                        <Route
                            path={RoutesPath.privacyPolicyProfilePages}
                            element={
                                <ProfileDataContainer />
                            }
                        />
                        <Route
                            path={RoutesPath.aboutUs}
                            element={
                                <AboutUsContainer />
                            }
                        />
                    </Routes>

                </div>
            </div>
        </>
    );
}

export default App
